<template lang="pug">
el-dialog(v-dialogDrag title="新建表单页" :visible.sync="dataDialog" width="400px" :before-close="handleClose")
  el-form(ref="form" :model="form" label-width="100px" size="small" label-position="top" :rules="rules")
    el-form-item(label="表单名称" prop="formName")
      el-input(v-model="form.formName",ref="formNameFocus" clearable maxlength="30" show-word-limit)
    el-form-item(label="表单编号" prop="formCode")
      el-input(v-model="form.formCode", clearable maxlength="30" show-word-limit)
    el-form-item(label="关联业务模型" prop="primaryMetaName")
      el-select(v-model="form.primaryMetaName")
        el-option(v-for="item in metaList" :key="item.tableName" :value="item.tableName" :label="item.businessName")
    el-form-item(label="表单初始布局" prop="layoutType")
      el-radio(v-model="form.layoutType" :label="1") 一栏
      el-radio(v-model="form.layoutType" :label="2") 二栏
      el-radio(v-model="form.layoutType" :label="3") 三栏
    el-form-item(label="表单页描述" prop="remark")
      el-input(v-model="form.remark" type="textarea" maxlength="50" show-word-limit)
  div(slot="footer")
    el-button(@click="handleClose" size="small") 取 消
    el-button(type="primary" @click="onSubmit" size="small") 确 定
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  data() {
    return {
      type: "", // "add" :新增；"edit":编辑
      dataDialog: false,
      metaList: [], //
      form: {
        groupId: "",
        groupName: "",
        formName: "",
        formCode: "",
        primaryMetaName: "",
        remark: "",
        layoutType: 1
      },
      rules: {
        formName: [{ required: true, message: "请输入表单名称", trigger: "blur" }],
        formCode: [{ required: true, message: "请输入表单编号", trigger: "blur" }],
        primaryMetaName: [{ required: true, message: "请关联业务模型", trigger: "change" }],
        layoutType: [{ required: true, message: "请选择初始布局", trigger: "change" }]
      }
    };
  },
  methods: {
    // 添加
    async addForm(data) {
      this.dataDialog = true;
      this.form.groupId = data?.groupId;
      this.form.groupName = data?.groupName;
      this.queryDynMetaListByGroupID();
      await this.$nextTick();
      this.$refs.formNameFocus.focus();
    },
    handleClose() {
      this.dataDialog = false;
    },
    async queryDynMetaListByGroupID() {
      const res = await metadataService.queryDynMetaListByGroupID(this.form.groupId);
      this.metaList = res.data || [];
    },
    /** @description: 新增参数描述
     * @param {formId} 新增传空表单ID
     * @param {formName} 表单名称
     * @param {formCode} 表单编号
     * @param {remark} 表单描述
     * @param {formGroupId} 分组ID
     * @param {formGroupName} 分组名称
     * @param {isPublish}  是否发布0:未发布 1:发布 默认0
     * @param {primaryMetaName} 主元数据对象
     * @param {otherMetaNames} 参与元数据对象 默认空
     * @param {stdFormName} 关联标准表单编号 默认空
     * @param {flowKey} 关联流程编号 默认空
     */
    async onSubmit() {
      const { groupId, groupName, formName, formCode, remark, primaryMetaName, layoutType } = this.form;
      const params = {
        formId: "",
        formGroupId: groupId,
        formGroupName: groupName,
        layoutType,
        formName,
        formCode,
        primaryMetaName,
        isPublish: 0,
        remark,
        otherMetaNames: "",
        stdFormName: "",
        flowKey: ""
      };
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await metadataService.dynFormSave(params);
            this.$success("添加成功!");
            this.$emit("initTree");
            this.form = {};
            this.dataDialog = false;
          } catch (error) {
            console.log(error);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
